var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81228 9.70703L1.87354 13.8103V20.7342C1.87354 20.929 2.03146 21.0874 2.22633 21.0874H7.0086C7.20347 21.0874 7.36139 20.9293 7.36139 20.7342V10.1131L6.25854 9.70703H5.81228Z",
    fill: "#706D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5525 12.9258H10.7706C10.5754 12.9258 10.4175 13.0839 10.4175 13.279V20.7346C10.4175 20.9297 10.5754 21.0882 10.7706 21.0882H15.5525C15.7474 21.0882 15.9053 20.9301 15.9053 20.7346V13.2786C15.9053 13.0839 15.7474 12.9258 15.5525 12.9258Z",
    fill: "#706D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5041 5.33029L21.6353 4.60352L18.4922 8.03624V20.7344C18.4922 20.9291 18.6501 21.0875 18.8454 21.0875H23.6276C23.8225 21.0875 23.9804 20.9294 23.9804 20.7344V5.44726C23.9608 5.45858 23.9431 5.47255 23.9231 5.48273C23.7403 5.57858 23.5349 5.62915 23.3284 5.62915C23.0265 5.62952 22.7347 5.52349 22.5041 5.33029Z",
    fill: "#706D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.70525 13.2814C0.890314 13.2814 1.07538 13.2086 1.21408 13.0645L5.71556 8.3748L13.5919 11.2762C13.861 11.3747 14.1618 11.3019 14.3559 11.0906L21.6089 3.16967L23.3057 4.59001C23.389 4.65944 23.5047 4.67152 23.6005 4.62171C23.6958 4.57152 23.7524 4.46926 23.7426 4.36096L23.3747 0.243347C23.3619 0.0961819 23.2318 -0.0121168 23.0852 0.00109032L18.972 0.368626C18.8646 0.37806 18.7733 0.45202 18.7409 0.555036C18.7307 0.588997 18.7274 0.62409 18.7304 0.658429C18.7368 0.727861 18.7696 0.793519 18.825 0.839556L20.5256 2.26253L13.636 9.78683L5.77134 6.88956C5.50788 6.79334 5.21313 6.86126 5.01864 7.06277L0.196794 12.0856C-0.0730757 12.3671 -0.0644069 12.8139 0.21677 13.0841C0.353213 13.2158 0.529232 13.2814 0.70525 13.2814Z",
    fill: "#706D9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.552598a39393b82fa2f64e1443a97211.svg";
export { ForwardRef as ReactComponent };